import { MantineColor } from '@mantine/core'

export type BaseProps = {
  color?: MantineColor
  url?: string
}

export enum FeatureCardLayout {
  Vertical = 'vertical',
  VerticalCenter = 'verticalCenter',
  Horizontal = 'horizontal',
  TwoColumns = 'two-columns',
}
